import { Subscription } from "rxjs";
import { AjaxResponse } from "rxjs/ajax";

type AjaxLike<T> = {
  subscribe: (handlers: {
    next?: (value: AjaxResponse<T>) => void;
    error?: (err: unknown) => void;
    complete?: () => void;
  }) => Subscription;
};

export function apiSubscribe<T>(
  request: AjaxLike<T>,
  handlers: {
    next: (body: T) => void;
    error?: () => void;
    complete?: () => void;
  }
): () => void {
  let cancelled = false;
  const sub = request.subscribe({
    next: (res) => {
      if (!cancelled) handlers.next(res.response);
    },
    error: () => {
      if (!cancelled) handlers.error?.();
    },
    complete: () => {
      if (!cancelled) handlers.complete?.();
    },
  });
  return () => {
    cancelled = true;
    sub.unsubscribe();
  };
}
